import { Typography, Box, Container } from '@mui/material';
import ReceiveInventory from '../components/ReceiveInventory';

export default function ReceivePage() {
  return (
    <Box sx={{ 
      width: '100%',
      minHeight: '100vh'
    }}> {/* Force push test */}
      <Typography variant="h4" component="h1" gutterBottom sx={{ mb: 3 }}>
        Receive Equipment
      </Typography>
      
      <ReceiveInventory />
    </Box>
  );
}